const SouthSudanSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112427)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.4396 12.2463C35.4108 5.05172 28.2958 0 19.9999 0C14.4769 0 9.47746 2.23898 5.8584 5.85852L10.867 12.2463H38.4396Z"
        fill="black"
      />
      <path
        d="M10.9238 27.6807L5.8584 34.1409C9.47746 37.7604 14.4769 39.9994 19.9999 39.9994C28.3238 39.9994 35.4591 34.9139 38.4705 27.6807H10.9238Z"
        fill="#496E2D"
      />
      <path
        d="M4.34766 14.7109V25.2181H39.3109C39.7595 23.5548 39.9998 21.806 39.9998 20.0008C39.9998 18.1694 39.7531 16.3959 39.292 14.7109H4.34766Z"
        fill="#A2001D"
      />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#0052B4"
      />
      <path
        d="M6.514 15.0264L8.95502 18.4327L12.9494 17.1636L10.4642 20.538L12.9052 23.9445L8.92799 22.6236L6.44268 25.998L6.47002 21.8071L2.49268 20.4861L6.48674 19.2171L6.514 15.0264Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112427">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SouthSudanSvg;
